export default __webpack_public_path__ + "static/media/07.ba091004.jpg";